import { Fragment } from "react";
import { Box } from "@mui/material";
import SenderDetails from "../SenderDetails";
import ReceiverDetails from "../ReceiverDetails";
import ReceiverDoorDetailsForm from "./ReceiverDoorDetailsForm";
import ParcelInfo from "../ParcelPoint/ParcelInfo";

const DoorForm = ({ type, payment_type, data}) => {
    return <Fragment>
        <SenderDetails />
        <div style={{ margin: "3vh" }} />
        <ReceiverDoorDetailsForm type={type} payment_type={payment_type} data={data}/>
        <div style={{ margin: "3vh" }} />
        {(type.includes('pp_')) && (<ParcelInfo type={type } payment_type={payment_type}/>)}
        <Box sx={{ borderBottom: "1px solid lightgrey", m: 2 }} />
        <ReceiverDetails type={type} />
        <div style={{ margin: "3vh" }} />
    </Fragment>
}

export default DoorForm;